import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Our Devices', path: '/products' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_healthcare-products/artifacts/0o4r6g9q_6F5E6702-51DA-435B-9CBD-CA2B0831C7B9.png"
              alt="Kalorama Medical Logo"
              className="h-12 w-12 object-contain"
            />
            <div>
              <div className="text-xl font-bold text-[#1e3a5f]">
                KALORAMA MEDICAL
              </div>
              <div className="text-xs text-gray-500">
                Innovating Health. Connecting Care
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-base font-medium transition-colors duration-200 relative group ${
                  isActive(item.path)
                    ? 'text-[#1e3a5f]'
                    : 'text-gray-600 hover:text-[#1e3a5f]'
                }`}
              >
                {item.name}
                {isActive(item.path) && (
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#7bb5d4]"></span>
                )}
              </Link>
            ))}
          </nav>

          {/* Contact Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-[#1e3a5f]">
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">(240) 355-8003</span>
            </div>
            <Link to="/contact">
              <Button className="bg-[#1e3a5f] hover:bg-[#2c5282] text-white rounded-full px-6 transition-all duration-300 hover:scale-105">
                Get Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-[#1e3a5f]" />
            ) : (
              <Menu className="h-6 w-6 text-[#1e3a5f]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`block py-3 text-base font-medium ${
                  isActive(item.path)
                    ? 'text-[#1e3a5f] bg-blue-50'
                    : 'text-gray-600'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex items-center space-x-2 text-[#1e3a5f] mb-3">
                <Phone className="h-4 w-4" />
                <span className="text-sm font-medium">(240) 355-8003</span>
              </div>
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-[#1e3a5f] hover:bg-[#2c5282] text-white rounded-full">
                  Get Quote
                </Button>
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
